import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

export default function PaymentCancelledPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const appointmentId = searchParams.get('appointment_id');
  const provider = searchParams.get('provider');

  const handleRetry = async () => {
    if (!appointmentId) {
      navigate('/');
      return;
    }

    try {
      const resp = await fetch('/api/online-booking/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ appointmentId, provider }),
      });
      const data = await resp.json();
      if (data.success && data.data?.checkoutUrl) {
        window.location.href = data.data.checkoutUrl;
        return;
      }
    } catch {
      // fall through
    }
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-accent-50 py-20">
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          <div className="flex items-center justify-center w-20 h-20 bg-orange-100 rounded-full mx-auto mb-6">
            <XCircle className="w-12 h-12 text-orange-600" />
          </div>

          <h1 className="text-2xl font-display font-bold text-textPrimary mb-4">
            {t('payment.cancelled.title', 'Payment cancelled')}
          </h1>

          <p className="text-textSecondary mb-8">
            {t(
              'payment.cancelled.description',
              'Your payment was cancelled. Your appointment has been saved and you can retry the payment at any time.'
            )}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            {appointmentId && (
              <button
                onClick={handleRetry}
                className="px-6 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors inline-flex items-center justify-center gap-2"
              >
                <RefreshCw className="w-4 h-4" />
                {t('payment.cancelled.retry', 'Retry payment')}
              </button>
            )}
            <button
              onClick={() => navigate('/')}
              className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors inline-flex items-center justify-center gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              {t('payment.cancelled.backHome', 'Back to home')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
